const IconClose = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="13"
            height="2"
            viewBox="0 0 13 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 1C0 0.447715 0.447715 0 1 0H12C12.5523 0 13 0.447715 13 1C13 1.55228 12.5523 2 12 2H1C0.447715 2 0 1.55228 0 1Z"
                fill="#1D1D1B"
            />
        </svg>
    )
}

export default IconClose
